// extracted by mini-css-extract-plugin
export default {"privacyModal":"PrivacyModal_privacyModal__wVpg+","closeBtn":"PrivacyModal_closeBtn__gDQrN","scaleIn":"PrivacyModal_scaleIn__C6ju9"};